export const areThirdPartyCookiesBlocked = (): Promise<boolean> => {
    return new Promise((resolve) => {
      const blob = new Blob(
        [
          `
          <!DOCTYPE html>
          <html>
            <body>
              <script>
                try {
                  document.cookie = "test=1";
                  const result = document.cookie.includes("test=1");
                  window.parent.postMessage(result, "*");
                } catch (e) {
                  window.parent.postMessage(false, "*");
                }
              </script>
            </body>
          </html>
        `,
        ],
        { type: "text/html" }
      );
  
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = URL.createObjectURL(blob);
  
      const handleMessage = (event: MessageEvent) => {
        if (typeof event.data === "boolean") {
          resolve(!event.data); // if cookie not set => blocked
          window.removeEventListener("message", handleMessage);
          document.body.removeChild(iframe);
        }
      };
  
      window.addEventListener("message", handleMessage);
      document.body.appendChild(iframe);
    });
  };